export default "__VITE_ASSET__Bon0Dag0__"